import { Box } from "@mui/material";
import { getTranslation } from "common";
import { useTranslations } from "hooks";
import React from "react";
import { safeHtml } from "utils/safeHtml";

const RobotsHelp = () => {
  const translations = useTranslations();

  return (
    <React.Fragment>
      <Box
        dangerouslySetInnerHTML={{
          __html: safeHtml(getTranslation(translations, "help.robots.main")),
        }}
      />
    </React.Fragment>
  );
};

export default RobotsHelp;
